const Spinner = () => {
    return (
        <div className="flex justify-center items-center h-full w-full">
            <div className="spinner">
                <div className="spinner-item"></div>
                <div className="spinner-item"></div>
                <div className="spinner-item"></div>
            </div>
        </div>
    );
};

export default Spinner;
